import React from "react";

import * as FileSaver from "file-saver";

import * as XLSX from "xlsx";
import { SiMicrosoftexcel } from "react-icons/si";
import "./Adminusers.css";

export const ExportCSV = ({ csvData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <button className="E-buttons" onClick={(e) => exportToCSV(csvData, fileName)}><SiMicrosoftexcel/> Export Data in excel sheet</button>
  );
};
